import request from '../utils/request';
import Vue from 'vue';
var reqData = {
    keyUrl: '',
    keyMethod: '',
    statusUrl: '',
    statusMethod: '',
    params: '',
    fileGiftKey: '',
};
var loadingMain = null;
function getKey() {
    // 获取文件key
    var keyUrl = reqData.keyUrl, keyMethod = reqData.keyMethod, params = reqData.params;
    loadingMain = Vue.prototype.$loading({
        spinner: 'el-icon-loading',
        background: 'rgba(300, 300, 300, 0.5)',
        customClass: 'loading',
        body: true,
    });
    request({
        url: keyUrl,
        method: keyMethod ? keyMethod : 'post',
        data: params,
        loadingControl: 'hand',
    }).then(function (res) {
        if (!res || res.errorCode)
            return loadingMain.close();
        var key = res.data;
        exportPolling(key);
    });
}
function exportPolling(key) {
    // 轮循次数
    var pollingTimes = 0;
    // 轮询下载接口
    var pollingMain = function () {
        getExportStatus(key).then(function (res) {
            // 轮循次数叠加  70s内未返回接口报网络超时
            pollingTimes++;
            if (!res || res.errorCode)
                return loadingMain.close();
            if (!res.data && pollingTimes < 140)
                return setTimeout(function () {
                    pollingMain();
                }, 500);
            if (!res.data && pollingTimes >= 140) {
                Vue.prototype.$message({
                    message: '网络超时,请重试!',
                    type: 'error',
                    showClose: true,
                });
                return loadingMain.close();
            }
            loadingMain.close();
            location.href = res.data;
        });
    };
    pollingMain();
}
function getExportStatus(key) {
    var _a;
    //下载主函数
    var statusUrl = reqData.statusUrl, statusMethod = reqData.statusMethod, fileGiftKey = reqData.fileGiftKey;
    return request({
        url: statusUrl,
        method: statusMethod ? statusMethod : 'post',
        data: (_a = {},
            _a[fileGiftKey || 'fileGiftKey'] = key,
            _a),
        loadingControl: 'hand',
    });
}
function exportData(requestData) {
    reqData = Object.assign({}, requestData);
    reqData.keyUrl && getKey();
}
export { exportData };
